import { Box, Spinner } from "@chakra-ui/react";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import TldrBase from "../TldrLogin/TldrBase";

class TldrOauthWaitingPage extends Component {
  render() {
    const { t } = this.props;
    return (
      <TldrBase>
        <Box textAlign="center">
          <Spinner size="sm" />
        </Box>
        <Box textAlign="center">{t("waiting")}</Box>
      </TldrBase>
    );
  }
}
export default withTranslation(["common"])(TldrOauthWaitingPage);
